import React from "react";
import { cn } from "../../../components/ui/primitives";
import { fmtPct } from "../utils/format";

export function MetricBadge({
  label,
  changePct,
}: {
  label: string;
  changePct: number;
}) {
  const up = changePct >= 0;
  return (
    <div
      className={cn(
        "min-w-[220px] rounded-xl border px-4 py-3 text-xs",
        up
          ? "border-emerald-400/20 bg-emerald-400/10 text-emerald-200"
          : "border-rose-400/20 bg-rose-400/10 text-rose-200"
      )}
    >
      <span className="font-semibold">{label}:</span>{" "}
      <span className="ml-1">{fmtPct(changePct, 2)}</span>
    </div>
  );
}
